import type { PropsWithChildren } from 'react';
import React from 'react';
import { useTheme } from '../../theme';
import { BadgeWrapper } from './view';

const MAX_COUNTER_SIZE = 100;

interface Props extends PropsWithChildren {
    className?: string;
    backgroundColor?: 'default' | 'gray' | 'red' | 'muted';
    textColor?: 'text' | 'mutedText';
}

const Badge = (props: Props) => {
    const theme = useTheme();
    const { children, className, backgroundColor = 'default', textColor = 'text' } = props;
    const counter = Number(children) >= MAX_COUNTER_SIZE ? '99+' : children;

    return (
        <BadgeWrapper
            backgroundColor={backgroundColor}
            textColor={textColor}
            theme={theme}
            className={className}
            data-cy="unreadMessagesCount"
        >
            {counter}
        </BadgeWrapper>
    );
};

export default Badge;
